import ResponsiveImage from "../../atoms/image/ResponsiveImage";
import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../../styles/cssinjs/helpers/variables.js";
export default function BoxShadowCard({
  data,
  hasLink,
  hasOffset,
  colCount = 3,
  className,
  isIconsInline = false,
}) {
  // Image Component
  const TheImage = ({ data }) => {
    return (
      <>
        <figure>
          <ResponsiveImage
            src={data.src}
            alt={data.alt}
            dpi={data.prefixes.dpi}
            mobile={data.prefixes.mobile}
            imgClass={`class-name`}
            wrapClass={`class-name`}
          />
        </figure>
        <style jsx>{`
          figure :global(img) {
            width: calc(100% + 44px);
            margin-left: -22px;
            margin-top: -24px;
            margin-bottom: 8px;
          }
          @media (max-width: ${viewport.tablet.sm}) {
            figure :global(img) {
              width: calc(100% + 40px);
              margin-left: -20px;
              margin-bottom: 20px;
            }
          }
        `}</style>
      </>
    );
  };
  // List Component
  let colCountClasses = ["zero", "one", "two", "three", "four"];
  const List = ({ data, index }) => {
    let offsetClasses = "";
    if (hasOffset && index == 1) {
      offsetClasses = " lg:-mt-5.2 md:-mt-5 ";
    }
    if (hasOffset && index > 1) {
      offsetClasses = " lg:-mt-5.2 ";
    }
    if (colCount === 2) {
      colCountClasses = `two`;
    }
    if (colCount === 3) {
      colCountClasses = `two`;
    }
    if (colCount === 4) {
      colCountClasses = `two`;
    }
    let gridGapClasses = "";
    if (index > 3) {
      gridGapClasses = " lg:mt-5 md:mt-2.5 ";
    }
    let allClasses = offsetClasses + gridGapClasses;
    return hasLink === true ? (
      <a
        className={`bg-white hover:box-shadow md:d-block ${allClasses}`}
        key={index}
        href={data.href}
      >
        {data.hasOwnProperty("image") && <TheImage data={data.image} />}
        <div
          className={`icon-title-wrap ${
            isIconsInline ? "fx fx--ns lg:mb-2" : ""
          }`}
        >
          {data.hasOwnProperty("icon") && (
            <figure
              className={`${isIconsInline ? "lg:mr-1 md:mr-1" : "lg:mb-2"} `}
              dangerouslySetInnerHTML={{ __html: data.icon }}
            />
          )}
          <h3
            className={`text-brandcolor ${
              isIconsInline ? "" : "lg:mb-3 lg:mt-4"
            }`}
            dangerouslySetInnerHTML={{ __html: data.title }}
          />
        </div>
        {Array.isArray(data.desc) ? (
          data.desc.map((item, index) => {
            return (
              <p
                key={index}
                dangerouslySetInnerHTML={{ __html: item }}
                className={`${isIconsInline ? "" : "lg:mb-2 "} ${
                  data.desc.length > 1 ? "md:mb-1.5" : ""
                }`}
              />
            );
          })
        ) : (
          <p dangerouslySetInnerHTML={{ __html: data.desc }} />
        )}
      </a>
    ) : (
      <li className={`bg-white hover:box-shadow ${allClasses}`} key={index}>
        {data.hasOwnProperty("image") && <TheImage data={data.image} />}
        <div
          className={`icon-title-wrap ${
            isIconsInline ? "fx fx--ns lg:mb-2" : ""
          }`}
        >
          {data.hasOwnProperty("icon") && (
            <figure
              className={` ${isIconsInline ? "lg:mr-1 md:mr-1" : "lg:mb-2"} `}
              dangerouslySetInnerHTML={{ __html: data.icon }}
            />
          )}
          {data.hasOwnProperty("number") && (
            <span
              className="numbered-list"
              dangerouslySetInnerHTML={{ __html: data.number }}
            />
          )}
          <h3
            className={`${isIconsInline ? "" : "lg:mb-3 lg:mt-4"}`}
            dangerouslySetInnerHTML={{ __html: data.title }}
          />
        </div>
        {Array.isArray(data.desc) ? (
          data.desc.map((item, index) => {
            return (
              <p
                key={index}
                dangerouslySetInnerHTML={{ __html: item }}
                className={`${isIconsInline ? "" : "lg:mb-2 "} ${
                  data.desc.length > 1 ? "md:mb-1.5" : ""
                }`}
              />
            );
          })
        ) : (
          <p dangerouslySetInnerHTML={{ __html: data.desc }} />
        )}
      </li>
    );
  };
  return (
    <ul
      className={`container card--default card--feature has-shadow ${className} has-${colCountClasses[colCount]}-col`}
    >
      {data?.map((item, index) => {
        return <List key={index} data={item} index={index + 1} />;
      })}
      <style jsx>{`
        ${isIconsInline
          ? `
          .icon-title-wrap figure{ 
              width: 24px!important; 
              height: 24px!important;
          }
          .icon-title-wrap figure svg{ 
            height: unset!important;
          }
          .industry-features ul li {
            box-shadow: 0 1px 2px 0 rgba(48, 58, 71, 0.2), 0 1px 3px 0 rgba(48, 58, 71, 0.1);
          }
          @media (max-width: ${viewport.tablet.sm}) {
            .card--default.card--feature.has-shadow > * {
              margin-bottom: 24px;
            }
            .card--default.card--feature.has-shadow > *:last-child {
              margin-bottom: 0;
            }
          }
          `
          : ``}
      `}</style>
    </ul>
  );
}
